import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="photo-manager"
export default class extends Controller {
  static targets = [
    "photoContainer",
    "photoImage",
    "placeholder",
    "fileInput",
    "removeFlag",
    "removeButton",
    "removeInfo",
    "undoButton",
  ];

  connect() {
    console.log("Photo manager controller connected");
  }

  removePhoto() {
    // Hide the photo and show placeholder
    if (this.hasPhotoContainerTarget) {
      this.photoContainerTarget.style.display = "none";
    }

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.style.display = "flex";
    }

    // Set the remove flag to true
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "true";
    }

    // Clear the file input
    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = "";
    }

    // Show remove info message
    if (this.hasRemoveInfoTarget) {
      this.removeInfoTarget.style.display = "block";
    }
  }

  undoRemove() {
    // Show the photo again and hide placeholder
    if (this.hasPhotoContainerTarget) {
      this.photoContainerTarget.style.display = "block";
    }

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.style.display = "none";
    }

    // Set the remove flag to false
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "false";
    }

    // Hide remove info message
    if (this.hasRemoveInfoTarget) {
      this.removeInfoTarget.style.display = "none";
    }
  }

  previewPhoto(event) {
    const file = event.target.files[0];

    if (file) {
      // If we were in remove mode, undo it first
      if (this.hasRemoveFlagTarget && this.removeFlagTarget.value === "true") {
        this.undoRemove();
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        // Update the image source
        if (this.hasPhotoImageTarget) {
          this.photoImageTarget.src = e.target.result;
        }

        // Show photo container and hide placeholder
        if (this.hasPhotoContainerTarget) {
          this.photoContainerTarget.style.display = "block";
        }

        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.style.display = "none";
        }
      };

      reader.readAsDataURL(file);
    }
  }
}
